import React from 'react';
import Correct from './Correct';

export default function PracticalWork() {
  const styles = {
    heading: {
      color: 'white'
    },
    img: {
      width: '30%',
      height: '30%'
    },
    imgBig: {
      width: '40%',
      height: '40%',
      marginBottom: '20%'
    }
  };
  return (
    <>
      <section data-background-color="CadetBlue">
        <h1 style={styles.heading}>TP</h1>
      </section>
      <section>
        <h2>Consignes</h2>
        <div style={{ textAlign: 'left', margin: '20px 0' }}>
          <h3>
            <span role="img" aria-label="files">
              📄
            </span>{' '}
            Fichiers du TP :
          </h3>
          <ul style={{ fontSize: '1.2em', lineHeight: '1.8' }}>
            <li>
              <a
                href="/TPs/TP-ARP/TP ARP.md"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#4ecdc4', textDecoration: 'none' }}>
                <span role="img" aria-label="document">
                  📋
                </span>{' '}
                TP ARP.md
              </a>
              - Énoncé du TP
            </li>
            {/* <li>
              <a
                href="/TPs/TP-ARP/getIp.sh"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#4ecdc4', textDecoration: 'none' }}>
                <span role="img" aria-label="wrench">
                  🔧
                </span>{' '}
                getIp.sh
              </a>
              - Script d'aide
            </li> */}
            <li>
              <a
                href="/TPs/TP-ARP/spoof.py"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#4ecdc4', textDecoration: 'none' }}>
                <span role="img" aria-label="snake">
                  🐍
                </span>{' '}
                spoof.py
              </a>
              - Script Python nécessaire pour l'exercice
            </li>
          </ul>
          <p style={{ marginTop: '30px', fontSize: '1.1em' }}>
            <strong>
              Rapport à alimenter pour l'avancement (markdown ou autre)
            </strong>
          </p>
        </div>
      </section>

      <section data-background-color="CadetBlue">
        <h1 style={styles.heading}>Correction</h1>
      </section>

      <Correct />
    </>
  );
}
